import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import './App.scss';

import countries from 'i18n-iso-countries'
import Nav from './Nav.js'
import Dashboard from './Dashboard.js'
import BeeCommandcenter from './BeeCommandcenter.js'
import API from './API.js'
import Licenses from './Licenses.js'
import LicensesTemp from './LicensesTemp.js'
import Thanks from './Thanks.js'
import Experiments from './Experiments.js'
import About from './About.js'
import Impressum from './Impressum.js'
import Footer from './Footer.js';
import Beekeeper from './Beekeeper.js';
import NotFoundPage from './NotFoundPage.js';

function layout(component, no_section) {
  return (
    <div className="honey-router-container">
      <Nav />
      {no_section ? component : set_section(component)}
      <Footer />
    </div>
  )
}

function set_section(component) {
  return (
    <section className="section honey-main-section">
      { component }
    </section>
  );
}

const basename = process.env.PUBLIC_URL || "/"

const router = createBrowserRouter([
  {
    path: "/api",
    element: layout(<API />, true),
  },
  {
    path: "/licenses",
    element: layout(<Licenses />, false),
  },
  {
    path: "/licensesTemp",
    element: layout(<LicensesTemp />, false),
  },
  {
    path: "/thanks",
    element: layout(<Thanks />, false),
  },
  {
    path: "/experiments",
    element: layout(<Experiments />, false),
  },
  {
    path: "/about",
    element: layout(<About />, false),
  },
  {
    path: "/impressum",
    element: layout(<Impressum />, false),
  },
  {
    path: "/beecommandcenter",
    element: layout(<BeeCommandcenter />, false),
  },
  {
    path: "/beekeeper",
    element: layout(<Beekeeper />, false),
  },
  {
    path: "/",
    element: layout(<Dashboard />, false),
  },
  {
    path: "*",
    element: layout(<NotFoundPage />, false),
  },
], { basename: basename } );

function App() {
  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));

  return (
    <div className="honey-app is-max-desktop">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
